export const MAILCHIMP_APP_ID = 10
export const RETURN_TO_IMPORT_KEY = 'mpz.mailchimp.returnToImport'
export const JUST_CONNECTED_KEY = 'mpz.mailchimp.justConnected'

export function markReturnToMailchimpImport() {
    sessionStorage.setItem(RETURN_TO_IMPORT_KEY, '1')
}

/**
 * @returns {boolean} true if the return-to-import flag was set
 */
export function consumeReturnToMailchimpImport() {
    if (sessionStorage.getItem(RETURN_TO_IMPORT_KEY) !== '1') return false
    sessionStorage.removeItem(RETURN_TO_IMPORT_KEY)
    return true
}

export function peekReturnToMailchimpImport() {
    return sessionStorage.getItem(RETURN_TO_IMPORT_KEY) === '1'
}

export function markMailchimpJustConnected() {
    sessionStorage.setItem(JUST_CONNECTED_KEY, '1')
}

/**
 * @returns {boolean} true if OAuth just completed and navigated into Import
 */
export function consumeMailchimpJustConnected() {
    if (sessionStorage.getItem(JUST_CONNECTED_KEY) !== '1') return false
    sessionStorage.removeItem(JUST_CONNECTED_KEY)
    return true
}

/**
 * Build Mailchimp OAuth authorize URL (Application 10), matching integrations add-app flow.
 * @param {object} appData Application record from GET /application/10
 * @param {string} userToken Account user token (RANDNO placeholder)
 * @param {string} trackingDomain siteMaster.trackingDomain
 * @returns {string}
 */
export function buildMailchimpOAuthAuthorizeUri(appData, userToken, trackingDomain) {
    let ourTrackingDomain = trackingDomain
    if (ourTrackingDomain === 'api.transpond.io') {
        ourTrackingDomain = 'api.mpzmail.com'
    } else if (ourTrackingDomain === 'localhost:8082') {
        ourTrackingDomain = 'localhost:8082'
    }

    let theURI = appData.oAuthAuthoriseUri
    theURI = theURI.replace(/\[OAUTHCLIENTID\]/g, appData.oAuthAppId)
    theURI = theURI.replace(/\[RANDNO\]/g, userToken)
    let redirectURI = window.location.origin
    if (redirectURI === 'https://app.transpond.io' || redirectURI === 'http://localhost:8080') {
        redirectURI = 'https://web.mpzmail.com'
    } else if (redirectURI === 'http://localhost:8082') {
        redirectURI = 'http://localhost:8082'
    }
    let toReplaceWith = redirectURI + '/cp/company/integrations/oAuth/response/' + appData.id
    if (appData.options && appData.options.backendAuth) {
        toReplaceWith = 'https://' + ourTrackingDomain + '/api/oauth/app/' + appData.id + '/oauth'
    }
    theURI = theURI.replace(/\[OAUTHREDIRECTURL\]/g, toReplaceWith)
    return theURI
}

/**
 * Set Import return flag and navigate to Mailchimp OAuth.
 */
export function startMailchimpOAuthConnect(appData, userToken, trackingDomain) {
    markReturnToMailchimpImport()
    window.open(buildMailchimpOAuthAuthorizeUri(appData, userToken, trackingDomain), '_self')
}
